var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{ref:"orderRecapModal",attrs:{"size":"lg","title":_vm.$t('shop.order.recap.title', {orderID: _vm.order != null ? _vm.order._id : ''}),"hide-footer":"","lazy":""}},[(_vm.order != null)?_c('Recap',{attrs:{"order":_vm.order},on:{"order-updated":_vm.onItemUpdated}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }